import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { bankReferralDetailUpdate } from '../../redux/bankReferralReducer';

import TextareaAutosize from '@material-ui/core/TextareaAutosize';

export default function BankReferralTextArea({ index, fieldName, width, tabIndex }) {
    const dispatch = useDispatch();
    const { entities } = useSelector(state => {
        return state.bankReferral;
    });

    const entity = entities[index];

    return <TextareaAutosize value={entity[fieldName] ? entity[fieldName] : ''} style={{ width: `${width}px` }} tabIndex={tabIndex} onChange={(e) => { dispatch(bankReferralDetailUpdate(index, fieldName, e.target.value)); }} />
}